import { jsx as _jsx } from "react/jsx-runtime";
import { Container, Flex, useMediaQuery, } from "@chakra-ui/react";
import AOS from "aos";
import { useEffect } from "react";
import { useScreenOrientation } from "../hooks/useScreenOrientation";
export default function LandingPage() {
    const [isMobileView] = useMediaQuery("(max-width: 420px)");
    const orientation = useScreenOrientation();
    useEffect(() => {
        AOS.init({ duration: 500 });
    }, []);
    return (_jsx(Container, { maxW: "100%", p: "0", background: "#111111", overflow: "hidden", children: _jsx(Flex, { w: "100%", h: "100vh", bg: "#000", justify: "center", align: "center", position: "relative", px: [6, 10, 20] }) }));
}
